import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { DELIVERY_TEAMS_ROUTE, wfmNodePath } from '../../config/wfm-routes';
import { useMonth } from '../../contexts/MonthContext';
import { wfmKeys } from '../../hooks/wfm-query';
import { TIER_LABELS } from '../../utils/wfm-tier-labels';
import { layerSubtitle } from './wfm-cells';
import { useWfmMonthParam } from './wfm-month-gate';

export const WFM_ROOT_LABEL = 'Cox Automotive Delivery';

function useCachedWfmPage(kind, id) {
  const { month } = useMonth();
  const teamMonth = useWfmMonthParam();
  const key = kind === 'teams' ? wfmKeys.team(id, teamMonth) : wfmKeys.node(id, month.format('YYYY-MM'));
  return useQuery({ queryKey: key, enabled: false }).data;
}

export function wfmTrailSubtitle(kind, data) {
  if (kind === 'teams') return data?.team ? layerSubtitle('Scrum team', data.team.members) : null;
  const node = data?.node;
  return node ? layerSubtitle(TIER_LABELS[node.tier] ?? 'Group', node.members) : null;
}

export default function WfmBreadcrumb({ kind, id, linkColor, textColor, mutedColor }) {
  const data = useCachedWfmPage(kind, id);
  const trail = data?.trail ?? [];
  const subtitle = wfmTrailSubtitle(kind, data);
  const link = { color: linkColor, fontSize: 15, fontWeight: 500, textDecoration: 'none' };
  const sep = <span style={{ color: mutedColor, fontSize: 15, margin: '0 6px' }}>/</span>;

  return (
    <nav aria-label="Delivery teams chain" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
      <Link to={DELIVERY_TEAMS_ROUTE} style={link}>{WFM_ROOT_LABEL}</Link>
      {trail.map((t, i) => (
        <React.Fragment key={t.node_id}>
          {sep}
          {i === trail.length - 1
            ? <span style={{ fontWeight: 700, fontSize: 15, color: textColor }}>{t.name}</span>
            : <Link to={wfmNodePath(t.node_id)} style={link}>{t.name}</Link>}
        </React.Fragment>
      ))}
      {subtitle && <span style={{ marginLeft: 12, color: mutedColor, fontSize: 15 }}>{subtitle}</span>}
    </nav>
  );
}
